import styled from 'styled-components'

import { Icon as DefaultIcon } from '@/components/ui/icon'

export const HelpSection = styled.div({
  display: 'flex',
  flexDirection: 'column',
})

export const Content = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['8'],
}))

export const Icon = styled(DefaultIcon)(({ theme }) => ({
  color: theme.colors.black500,
}))

export const Title = styled.h3(({ theme }) => ({
  color: theme.colors.black800,
  fontSize: '1.8rem',
  fontWeight: 600,
}))

export const Description = styled.p(({ theme }) => ({
  color: theme.colors.black500,
  fontSize: '1.4rem',
  fontWeight: 500,
}))

export const Link = styled.a(({ theme }) => ({
  color: theme.colors.blue600,
  fontWeight: 500,
}))
